<!-- Hero Section -->
<section class="pricing-hero">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8 text-center">
        <span class="hero-badge">{{ 'pricing.badge' | translate }}</span>
        <h1 class="hero-title">{{ 'pricing.title' | translate }}</h1>
        <p class="hero-subtitle">{{ 'pricing.subtitle' | translate }}</p>

        <!-- Billing Toggle -->
        <div class="billing-toggle">
          <span [class.active]="!isAnnual">{{ 'pricing.monthly' | translate }}</span>
          <button class="toggle-btn" (click)="toggleBilling()">
            <span class="toggle-slider" [class.annual]="isAnnual"></span>
          </button>
          <span [class.active]="isAnnual">{{ 'pricing.annual' | translate }} <span class="save-badge">{{ 'pricing.save20' | translate }}</span></span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Pricing Cards -->
<section class="pricing-cards-section">
  <div class="container" style="max-width: 1200px">
    <div class="row g-4 justify-content-center">
      <!-- Starter Plan -->
      <div class="col-lg-4">
        <div class="pricing-card">
          <div class="pricing-header">
            <h3>{{ 'pricing.starter.name' | translate }}</h3>
            <p class="pricing-tagline">{{ 'pricing.starter.tagline' | translate }}</p>
            <div class="pricing-price">
              <span class="currency">$</span>
              <span class="amount">{{ isAnnual ? '0' : '0' }}</span>
              <span class="period">{{ 'pricing.perMonth' | translate }}</span>
            </div>
            <p class="pricing-billed">{{ 'pricing.starter.billed' | translate }}</p>
          </div>

          <div class="pricing-body">
            <a routerLink="/auth/register-user" class="btn-pricing">{{ 'pricing.starter.cta' | translate }}</a>

            <div class="pricing-features">
              <p class="features-title">{{ 'pricing.whatsIncluded' | translate }}</p>
              <ul>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.members25' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.horses10' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.basicEvents' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.memberPortal' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.emailSupport' | translate }}</li>
                <li class="disabled"><i class="fa fa-times"></i> {{ 'pricing.features.onlinePayments' | translate }}</li>
                <li class="disabled"><i class="fa fa-times"></i> {{ 'pricing.features.lessonBooking' | translate }}</li>
                <li class="disabled"><i class="fa fa-times"></i> {{ 'pricing.features.customBranding' | translate }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Professional Plan -->
      <div class="col-lg-4">
        <div class="pricing-card pricing-card-featured">
          <div class="pricing-badge">{{ 'pricing.mostPopular' | translate }}</div>
          <div class="pricing-header">
            <h3>{{ 'pricing.professional.name' | translate }}</h3>
            <p class="pricing-tagline">{{ 'pricing.professional.tagline' | translate }}</p>
            <div class="pricing-price">
              <span class="currency">$</span>
              <span class="amount">{{ isAnnual ? '39' : '49' }}</span>
              <span class="period">{{ 'pricing.perMonth' | translate }}</span>
            </div>
            <p class="pricing-billed">{{ isAnnual ? ('pricing.professional.billedAnnual' | translate) : ('pricing.professional.billedMonthly' | translate) }}</p>
          </div>

          <div class="pricing-body">
            <a routerLink="/auth/register-user" class="btn-pricing-featured">{{ 'pricing.professional.cta' | translate }}</a>

            <div class="pricing-features">
              <p class="features-title">{{ 'pricing.everythingInStarter' | translate }}</p>
              <ul>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.unlimitedMembers' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.unlimitedHorses' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.advancedEvents' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.onlinePaymentProcessing' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.lessonBookingSystem' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.arenaScheduling' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.emailSmsReminders' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.prioritySupport' | translate }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Enterprise Plan -->
      <div class="col-lg-4">
        <div class="pricing-card">
          <div class="pricing-header">
            <h3>{{ 'pricing.enterprise.name' | translate }}</h3>
            <p class="pricing-tagline">{{ 'pricing.enterprise.tagline' | translate }}</p>
            <div class="pricing-price">
              <span class="currency">$</span>
              <span class="amount">{{ isAnnual ? '119' : '149' }}</span>
              <span class="period">{{ 'pricing.perMonth' | translate }}</span>
            </div>
            <p class="pricing-billed">{{ isAnnual ? ('pricing.enterprise.billedAnnual' | translate) : ('pricing.enterprise.billedMonthly' | translate) }}</p>
          </div>

          <div class="pricing-body">
            <a routerLink="/about" class="btn-pricing">{{ 'pricing.enterprise.cta' | translate }}</a>

            <div class="pricing-features">
              <p class="features-title">{{ 'pricing.everythingInProfessional' | translate }}</p>
              <ul>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.multiLocation' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.customIntegrations' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.apiAccess' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.customBranding' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.advancedAnalytics' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.dedicatedManager' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.phoneSupport' | translate }}</li>
                <li><i class="fa fa-check"></i> {{ 'pricing.features.customTraining' | translate }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Feature Comparison -->
<section class="comparison-section">
  <div class="container" style="max-width: 1000px">
    <div class="text-center mb-5">
      <h2 class="section-title">{{ 'pricing.comparison.title' | translate }}</h2>
      <p class="section-subtitle">{{ 'pricing.comparison.subtitle' | translate }}</p>
    </div>

    <div class="comparison-table-wrapper">
      <table class="comparison-table">
        <thead>
          <tr>
            <th>{{ 'pricing.comparison.features' | translate }}</th>
            <th>{{ 'pricing.starter.name' | translate }}</th>
            <th class="featured">{{ 'pricing.professional.name' | translate }}</th>
            <th>{{ 'pricing.enterprise.name' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="category">
            <td colspan="4">{{ 'pricing.comparison.memberManagement' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.numMembers' | translate }}</td>
            <td>25</td>
            <td class="featured">{{ 'pricing.unlimited' | translate }}</td>
            <td>{{ 'pricing.unlimited' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.memberProfiles' | translate }}</td>
            <td><i class="fa fa-check"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.membershipTiers' | translate }}</td>
            <td>2</td>
            <td class="featured">{{ 'pricing.unlimited' | translate }}</td>
            <td>{{ 'pricing.unlimited' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.automatedRenewals' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>

          <tr class="category">
            <td colspan="4">{{ 'pricing.comparison.horseManagement' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.numHorses' | translate }}</td>
            <td>10</td>
            <td class="featured">{{ 'pricing.unlimited' | translate }}</td>
            <td>{{ 'pricing.unlimited' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.healthRecords' | translate }}</td>
            <td><i class="fa fa-check"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.competitionHistory' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>

          <tr class="category">
            <td colspan="4">{{ 'pricing.comparison.eventsBooking' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.eventManagement' | translate }}</td>
            <td>{{ 'pricing.basic' | translate }}</td>
            <td class="featured">{{ 'pricing.advanced' | translate }}</td>
            <td>{{ 'pricing.advanced' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.onlineRegistration' | translate }}</td>
            <td><i class="fa fa-check"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.lessonBooking' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.arenaScheduling' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>

          <tr class="category">
            <td colspan="4">{{ 'pricing.comparison.paymentsBilling' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.onlinePayments' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.invoicing' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.financialReports' | translate }}</td>
            <td>{{ 'pricing.basic' | translate }}</td>
            <td class="featured">{{ 'pricing.advanced' | translate }}</td>
            <td>{{ 'pricing.custom' | translate }}</td>
          </tr>

          <tr class="category">
            <td colspan="4">{{ 'pricing.comparison.supportExtras' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.emailSupport' | translate }}</td>
            <td><i class="fa fa-check"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.prioritySupport' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.phoneSupport' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-times text-muted"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.customBranding' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-times text-muted"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>{{ 'pricing.comparison.apiAccess' | translate }}</td>
            <td><i class="fa fa-times text-muted"></i></td>
            <td class="featured"><i class="fa fa-times text-muted"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>

<!-- FAQ Section -->
<section class="faq-section">
  <div class="container" style="max-width: 800px">
    <div class="text-center mb-5">
      <h2 class="section-title">{{ 'pricing.faq.title' | translate }}</h2>
    </div>

    <div class="faq-list">
      <div class="faq-item">
        <h4>{{ 'pricing.faq.q1' | translate }}</h4>
        <p>{{ 'pricing.faq.a1' | translate }}</p>
      </div>

      <div class="faq-item">
        <h4>{{ 'pricing.faq.q2' | translate }}</h4>
        <p>{{ 'pricing.faq.a2' | translate }}</p>
      </div>

      <div class="faq-item">
        <h4>{{ 'pricing.faq.q3' | translate }}</h4>
        <p>{{ 'pricing.faq.a3' | translate }}</p>
      </div>

      <div class="faq-item">
        <h4>{{ 'pricing.faq.q4' | translate }}</h4>
        <p>{{ 'pricing.faq.a4' | translate }}</p>
      </div>

      <div class="faq-item">
        <h4>{{ 'pricing.faq.q5' | translate }}</h4>
        <p>{{ 'pricing.faq.a5' | translate }}</p>
      </div>

      <div class="faq-item">
        <h4>{{ 'pricing.faq.q6' | translate }}</h4>
        <p>{{ 'pricing.faq.a6' | translate }}</p>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
  <div class="container text-center">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <h2 class="cta-title">{{ 'pricing.cta.title' | translate }}</h2>
        <p class="cta-text">{{ 'pricing.cta.subtitle' | translate }}</p>
        <div class="cta-buttons">
          <a routerLink="/auth/register-user" class="btn-cta-primary">
            {{ 'pricing.cta.startTrial' | translate }}
            <i class="fa fa-arrow-right ms-2"></i>
          </a>
          <a routerLink="/about" class="btn-cta-secondary">
            {{ 'pricing.cta.contactSales' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
